export default __webpack_public_path__ + "static/media/TermsOfServicePage.353b0a2b.jpeg";